
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Shop from './components/Shop';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Navigation from './components/Navigation';

export default function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-stone-100">
      <Navigation />
      <Hero scrollY={scrollY} />
      <About scrollY={scrollY} />
      <Shop scrollY={scrollY} />
      <Testimonials scrollY={scrollY} />
      <Contact scrollY={scrollY} />
    </div>
  );
}
